"use client";

/**
 * useIsMobile — 현재 뷰포트가 모바일 크기인지 여부를 반환하는 훅.
 *
 * matchMedia로 브레이크포인트를 감지하며, 리사이즈에 반응한다.
 * 데스크탑/모바일 UI를 분기할 때 사용한다. (기본 768px 미만 = 모바일)
 *
 * @param breakpoint 모바일로 간주할 최대 px (기본 768)
 * @example
 * const isMobile = useIsMobile();
 * return isMobile ? <MobileNav /> : <DesktopNav />;
 */
import { useEffect, useState } from "react";

export function useIsMobile(breakpoint = 768) {
  // SSR 단계에서는 undefined → 클라이언트 마운트 후 실제 값으로 결정한다.
  const [isMobile, setIsMobile] = useState<boolean | undefined>(
    undefined
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [breakpoint]);

  return !!isMobile;
}
